import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

export const DEFAULT_MIN_DATE: NgbDateStruct = { year: 1900, month: 1, day: 1 };
export const DEFAULT_MAX_DATE: NgbDateStruct = { year: 2200, month: 12, day: 31 };

export const toNgbDateStruct = (input?: string | Date) => {
  let d: Date;

  if (!input) {
    d = new Date();
  } else if (input instanceof Date) {
    d = input;
  } else {
    d = new Date(input);
  }

  if (isNaN(d.getTime())) {
    throw new Error(`Invalid date value provided: "${input}"`);
  }

  return {
    year: d.getFullYear(),
    month: d.getMonth() + 1,
    day: d.getDate(),
  };
};
